import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacategory,
    Image,
    KeyboardAvoidingView,
    Alert,
    TouchableOpacity
} from "react-native";
import HMActionBar from "../../../../customviews/HMActionBar";
const {width: SCREEN_WIDTH} = Dimensions.get("window");
import i18n from '../../../../I18n/i18n.js';
import {moderateScale} from "../../../../tools/Scaling";

import  Colors from "../../../../tools/Colors";
// import HMImageBackground from "../../../../customviews/HMImageBackground";
import HMListDiffSize from "../../../../customviews/HMListDiffSize";
import HMLoading from "../../../../customviews/HMLoading";
import {AsyngStorageClass} from "../../../../tools/AsyngStorageClass";
import {typeExport} from "../../../../redux/store/type";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import store from "../../../../redux/store";
import {serviceActionSuccess} from "./action/ActionCategoryScreen";
import EmptyView from "../../../../customviews/empty/EmptyView";
import {Tools} from "../../../../tools/Tools";
import HMAnimation from '../../../../customviews/animation/HMAnimation';

let container = null;

export default class CategoryScreen extends Component {


    constructor(props) {
        super(props);
        container = this;
        this.state = {
            modalHeight: 0,
            /*    data: [
                    {
                        "id": "44",
                        "name": "مذهبی تاریخی",
                        "type": "1",
                        "menu_id": "7",
                        "size": "1",
                        "size_mobile": "0",
                        "background_color": "#424791",
                        "thumbnail": "http:\/\/app.arak.ir\/wp-content\/uploads\/2018\/11\/Historical.png",
                        "priority": "1",
                        "active": "1",
                        "link": "16",
                        "create_at": "2018-10-31 15:42:29",
                        "update_at": "2019-09-07 08:56:59",
                        "font_color": "#ffffff",
                        "is_deleted": "0",
                        "width": "4",
                        "height": "4",
                        "link_url": "http:\/\/185.113.56.35\/wp-json\/satia\/v1\/posts?category=9"
                    },
                    {
                        "id": "45",
                        "name": "مساجد",
                        "type": "1",
                        "menu_id": "7",
                        "size": "1",
                        "size_mobile": "0",
                        "background_color": "#424791",
                        "thumbnail": "http:\/\/app.arak.ir\/wp-content\/uploads\/2018\/11\/mosque.png",
                        "priority": "2",
                        "active": "1",
                        "link": "12",
                        "create_at": "2018-10-31 15:43:46",
                        "update_at": "2019-09-07 08:58:36",
                        "font_color": "#ffffff",
                        "is_deleted": "0",
                        "width": "4",
                        "height": "4",
                        "link_url": "http:\/\/185.113.56.35\/wp-json\/satia\/v1\/posts?category=8"
                    },
                    {
                        "id": "46",
                        "name": "رستوران ها",
                        "image": PathFile.image.Restaurant,

                        "type": "1",
                        "menu_id": "7",
                        "size": "1",
                        "size_mobile": "0",
                        "background_color": "#424791",
                        "thumbnail": "http:\/\/app.arak.ir\/wp-content\/uploads\/2018\/11\/resturant.png",
                        "priority": "3",
                        "active": "1",
                        "link": "17",
                        "create_at": "2018-10-31 15:44:16",
                        "update_at": "2019-09-07 08:58:54",
                        "font_color": "#ffffff",
                        "is_deleted": "0",
                        "width": "1",
                        "height": "3",
                        "link_url": "http:\/\/185.113.56.35\/wp-json\/satia\/v1\/posts?category=10"
                    },
                    {
                        "id": "54",
                        "name": "هتل ها",
                        "image": PathFile.image.Hotel,

                        "type": "1",
                        "menu_id": "7",
                        "size": "3",
                        "size_mobile": "0",
                        "background_color": "#424791",
                        "thumbnail": "http:\/\/app.arak.ir\/wp-content\/uploads\/2018\/11\/hotel-1.png",
                        "priority": "4",
                        "active": "1",
                        "link": "15",
                        "create_at": "2018-11-01 12:20:07",
                        "update_at": "2019-09-07 08:57:47",
                        "font_color": "#ffffff",
                        "is_deleted": "0",
                        "width": "1",
                        "height": "3",
                        "link_url": "http:\/\/185.113.56.35\/wp-json\/satia\/v1\/posts?category=11"
                    },
                    {
                        "id": "53",
                        "name": "موزه ها",
                        "type": "1",
                        "menu_id": "7",
                        "size": "3",
                        "size_mobile": "0",
                        "background_color": "#424791",
                        "thumbnail": "http:\/\/app.arak.ir\/wp-content\/uploads\/2018\/11\/public-museum-sign-1.png",
                        "priority": "5",
                        "active": "1",
                        "link": "14",
                        "create_at": "2018-11-01 12:19:09",
                        "update_at": "2019-09-07 08:58:05",
                        "font_color": "#ffffff",
                        "is_deleted": "0",
                        "width": "4",
                        "height": "4",
                        "link_url": "http:\/\/185.113.56.35\/wp-json\/satia\/v1\/posts?category=12"
                    },
                    {
                        "id": "52",
                        "name": "سفره خانه ها",
                        "type": "1",
                        "menu_id": "7",
                        "size": "1",
                        "size_mobile": "0",
                        "background_color": "#424791",
                        "thumbnail": "http:\/\/app.arak.ir\/wp-content\/uploads\/2018\/11\/coffee-pot.png",
                        "priority": "6",
                        "active": "1",
                        "link": "13",
                        "create_at": "2018-11-01 12:17:43",
                        "update_at": "2019-09-07 08:59:48",
                        "font_color": "#ffffff",
                        "is_deleted": "0",
                        "width": "4",
                        "height": "4",
                        "link_url": "http:\/\/185.113.56.35\/wp-json\/satia\/v1\/posts?category=14"
                    },
                    {
                        "id": "75",
                        "name": "پارک ها",
                        "type": "1",
                        "menu_id": "7",
                        "size": "1",
                        "size_mobile": "0",
                        "background_color": "#424791",
                        "thumbnail": "http:\/\/app.arak.ir\/wp-content\/uploads\/2018\/11\/PARK-.-300x229.png",
                        "priority": "6",
                        "active": "1",
                        "link": "25",
                        "create_at": "2018-11-12 13:42:00",
                        "update_at": "2019-09-07 08:57:23",
                        "font_color": "#ffffff",
                        "is_deleted": "0",
                        "width": "4",
                        "height": "4",
                        "link_url": "http:\/\/185.113.56.35\/wp-json\/satia\/v1\/posts?category=19"
                    }
                ]*/
        };

    }


    componentWillReceiveProps(propss) {


    }

    componentDidMount() {


        this.getData()

    }

    componentWillUnmount() {
        this.props.callserviceActionRefresh()
    }

    GoScreen() {

    }

    async getData() {
        if (store.getState().reducerSplashGetAllData.Connection) {

           // let {item} = this.props.route.params;
            let _params = this.props.route.params;
            let item = JSON.parse(_params.item);
            let paramss = {
                "id": item.link,
                "lang": i18n.locale,
                "imei": 0,
                "link_type": item.link_type,
               // 'tenant_id': store.getState().reducerSplashGetAllData?.City?.tenant_id,

                // "after": "0000-00-00"
            };
            paramss = Tools.addAllParams(paramss);

            //this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetCategoryScreen, _GET)
            this.props.callService(typeExport.UrlGetCategoryScreen, paramss, typeExport.TypeGetCategoryScreen, typeExport._GET)

        } else {
            let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListCategory + `${this.props.route.params.item.id}`)
            //this.props.callServiceSuccess(data, 0)
            if (data !== null)
                store.dispatch(serviceActionSuccess(data))
            else
                store.dispatch(serviceActionSuccess([]))
        }

    }

    render() {
       // let {item} = this.props.route.params
        let _params = this.props.route.params;
        let item = JSON.parse(_params.item);
        return (
            <View style={{position: 'relative', flex: 1}}>

{/*

                <HMImageBackground
                />
*/}

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBar menu
                                     props={this.props} statusBarTransparent
                            // text={i18n.t('Privatizations.title')}
                                     text={(item.name ? item.name : (item.title ? item.title : ''))}

                                     headerVisibility
                                     more_menu
                                     back
                                     onBackPress={() => this.props.navigation.pop()}

                        />
                        <View style={{flex: 1, paddingHorizontal: moderateScale(3)}}>
                            {
                                this.props.results === null ?
                                    <HMLoading/>
                                    :
                                    <View style={{flex: 1}}>
                                        <ScrollView>
                                            <View style={{flex: 1,}}>


                                                <HMListDiffSize card={true} title  data={this.props.results}

                                                                animationTypeIndex={0}
                                                                animationTypeIndexSub={2}
                                                                duration={1000}
                                                                delay={100}

                                                />

                                                {/*
                                                <HMListDiffSize data={this.state.data}  title/>
*/}
                                            </View>
                                        </ScrollView>
                                        <EmptyView
                                            empty={!(this.props.results != null && this.props.results.length !== 0)}/>
                                    </View>
                            }


                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData()}/> : null
                            }
                        </View>
                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

}


const styles = StyleSheet.create({
    container: {
        marginVertical: 5,
        borderRadius: 4,
        borderStyle: 'solid',
        borderWidth: 2,
        borderColor: Colors.green,
        backgroundColor: Colors.white,
        flex: 0,
        height: 'auto',
        overflow: 'hidden'
    },
    input: {
        height: moderateScale(100),
        backgroundColor: Colors.white,
        fontWeight: '600',
        fontSize: 11,
    },
    /* size: {
         input: moderateScale(100),
         icon: 20
     }*/
});


